<template>
  <div>
    <v-card
      v-for="(linha, linhaIdx) in celulas"
      :key="linhaIdx"
      tile
      outlined
      :class="`py-2 ${linhaIdx !== 0 ? 'mt-6' : ''}`"
    >
      <v-card-title class="pl-2 pt-1">
        {{ linhaIdx + 1 }}ª linha
      </v-card-title>

      <v-row class="d-flex align-center px-2">
        <celula
          v-for="(componenteData, componenteIdx) in linha"
          :key="componenteIdx"
          :componente-data="componenteData"
          :celula-options="new CelulaOptions({ qtdColunasPorCelula, usePadding: true, outlined: true })"
          :celula-componente-options="getCelulaComponenteOptions(componenteData)"
          @refetch-data="$emit('refetch-data')"
        >
        </celula>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import Celula from './Celula.vue'
import Componente from '@/models/entities/formulario/componente/Componente'
import CelulaOptions from '@/models/props/CelulaOptions'
import CelulaComponenteOptions from '@/models/props/CelulaComponenteOptions'
import ComponenteAssinaturaOptions from '@/models/props/ComponenteAssinaturaOptions'

export default {
  components: {
    Celula,
  },

  props: {
    secaoData: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const celulas = ref([])
    const qtdColunasPorCelula = computed(() => Math.floor(12 / props.secaoData.colunas))

    function inicializarCelulas(idSecao, qtdLinhas, qtdColunas) {
      celulas.value = new Array(qtdLinhas)
      for (let linha = 0; linha < qtdLinhas; linha += 1) {
        celulas.value[linha] = new Array(qtdColunas)
        for (let coluna = 0; coluna < qtdColunas; coluna += 1) {
          celulas.value[linha][coluna] = new Componente({
            idFormularioSecao: idSecao,
            linha: linha + 1,
            coluna: coluna + 1,
          })
        }
      }
    }
    function preencherCelulas(elementos, qtdColunas) {
      elementos.forEach((linha, linhaIdx) => {
        if (linha.length < qtdColunas) {
          linha.forEach(componente => {
            celulas.value[linhaIdx][componente.coluna - 1] = componente
          })
        } else {
          celulas.value[linhaIdx] = linha
        }
      })
    }
    function gerarCelulas(secaoData) {
      const { id, linhas, colunas, elementos } = secaoData
      inicializarCelulas(id, linhas, colunas)
      preencherCelulas(elementos, colunas)
    }

    watch(props.secaoData, newSecaoData => { gerarCelulas(newSecaoData) }, { immediate: true })

    function getCelulaComponenteOptions(componenteData) {
      return new CelulaComponenteOptions({
        ...componenteData,
        mostrarIcones: true,
      })
    }

    function getComponenteAssinaturaOptions(componenteData) {
      return new ComponenteAssinaturaOptions({
        formularioId: props.formularioId,
        componenteId: componenteData.id,
        mensagemDeAlerta: 'Este ticket já tem uma assinatura feita e não pode ser alterada.',
      })
    }

    return {
      celulas,
      qtdColunasPorCelula,
      getCelulaComponenteOptions,
      getComponenteAssinaturaOptions,
      CelulaOptions,
    }
  },
}
</script>
